module.exports = __webpack_public_path__ + "static/img/icon h spys 1.131f04a0.svg";